// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineArrowDownload = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 15.25C11.59 15.25 11.25 14.91 11.25 14.5V8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V14.5C12.75 14.91 12.41 15.25 12 15.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.0014 16.2514C11.8114 16.2514 11.6214 16.1814 11.4714 16.0314L8.47141 13.0314C8.18141 12.7414 8.18141 12.2614 8.47141 11.9714C8.76141 11.6814 9.24141 11.6814 9.53141 11.9714L12.0014 14.4414L14.4714 11.9714C14.7614 11.6814 15.2414 11.6814 15.5314 11.9714C15.8214 12.2614 15.8214 12.7414 15.5314 13.0314L12.5314 16.0314C12.3814 16.1814 12.1914 16.2514 12.0014 16.2514Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineArrowDownload };
